import * as types from './mutation_types'

export default {}